import type { UpdateOwnerInput } from '@chukua/common';
import { useState } from 'react';
import { useToast } from '../../../../../shared/hooks/use-toast';
import { updateOwner } from '../owners.api';
import { useOwnerRecord } from './use-owner-record';

/** An owner's own page: its record (`useOwnerRecord`) plus the Details tab's mutation. */
export function useOwnerDetail(id: string) {
  const { state, reload } = useOwnerRecord(id);
  const [updateError, setUpdateError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const toast = useToast();

  async function update(input: UpdateOwnerInput): Promise<boolean> {
    setUpdateError(null);
    setSaving(true);
    try {
      await updateOwner(id, input);
      await reload();
      toast.success('Owner updated');
      return true;
    } catch {
      setUpdateError('Could not save — check the fields and try again.');
      return false;
    } finally {
      setSaving(false);
    }
  }

  return { state, updateError, saving, update, reload };
}
